import { render, staticRenderFns } from "./FAQHomepage.vue?vue&type=template&id=9041906e&"
import script from "./FAQHomepage.vue?vue&type=script&lang=js&"
export * from "./FAQHomepage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports